import { CartErrorEvent, CartLinesUpdateEvent } from '@shopify/events';

const active = new WeakSet();
const busyCards = new WeakSet();

function init(root) {
  if (!(root instanceof HTMLElement) || active.has(root)) return;
  active.add(root);
  const live = root.querySelector('[data-gn-live]');
  const say = (message) => { if (live) live.textContent = message; };
  const label = root.dataset.gnAddLabel || 'Aggiungi';

  root.addEventListener('click', (event) => {
    const option = event.target.closest('[data-gn-opt]');
    if (!option || !root.contains(option)) return;
    event.preventDefault();
    const card = option.closest('[data-gn-card]');
    if (!card) return;
    card.querySelectorAll('[data-gn-opt]').forEach((button) => button.setAttribute('aria-pressed', String(button === option)));
    card.dataset.variantId = option.dataset.variantId;
    card.dataset.variantAvailable = option.dataset.available;
    const price = card.querySelector('[data-gn-price-now]');
    if (price) price.textContent = option.dataset.price;
    const compare = card.querySelector('[data-gn-price-was]');
    if (compare) { compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare; }
    card.querySelectorAll('[data-gn-add]').forEach((button) => {
      const available = option.dataset.available === 'true';
      button.disabled = !available || busyCards.has(card);
      button.textContent = available ? label : 'Esaurito';
    });
  });

  root.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-gn-add]');
    if (!(button instanceof HTMLButtonElement) || !root.contains(button) || button.disabled || button.dataset.gnPending === 'true') return;
    const card = button.closest('[data-gn-card]');
    const id = card?.dataset.variantId;
    if (!id || busyCards.has(card)) return;
    event.preventDefault();
    event.stopPropagation();
    busyCards.add(card);
    card.querySelectorAll('[data-gn-add]').forEach((item) => {
      item.dataset.gnPending = 'true';
      item.disabled = true;
      item.setAttribute('aria-busy', 'true');
    });
    const original = button.textContent;
    const deferred = CartLinesUpdateEvent.createPromise();
    root.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add', context: 'product', lines: [{ merchandiseId: String(id), quantity: 1 }],
      promise: deferred.promise, detail: { source: 'gn-product-list', productId: card.dataset.productId },
    }));
    try {
      const components = [...document.querySelectorAll('cart-items-component[data-section-id]')];
      const sections = [...new Set(components.map((item) => item.dataset.sectionId).filter(Boolean))];
      const body = new FormData();
      body.append('id', String(id)); body.append('quantity', '1');
      if (sections.length) body.append('sections', sections.join(','));
      body.append('sections_url', window.location.pathname);
      const response = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body });
      const result = await response.json();
      if (!response.ok || result.status || result.errors) throw new Error(result.description || result.message || 'Unable to add item');
      let cart = null;
      try {
        const cartResponse = await fetch(`${window.Theme?.routes?.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } });
        if (cartResponse.ok) cart = await cartResponse.json();
      } catch { /* add succeeded; drawer can morph returned sections */ }
      deferred.resolve({ cart: cart ? CartLinesUpdateEvent.createCartFromAjaxResponse({ ...cart, sections: result.sections }) : null, detail: { sections: result.sections, items: result.items, source: 'gn-product-list', didError: false, refreshFailed: !cart } });
      button.textContent = 'Aggiunto';
      say(`${result.product_title || 'Prodotto'} aggiunto al carrello.`);
    } catch (error) {
      deferred.reject(error);
      document.dispatchEvent(new CartErrorEvent({ error: error.message, code: 'INVALID', detail: { source: 'gn-product-list' } }));
      button.textContent = 'Riprova'; say('Non è stato possibile aggiungere il prodotto. Riprova.');
    } finally {
      window.setTimeout(() => {
        busyCards.delete(card);
        card.querySelectorAll('[data-gn-add]').forEach((item) => {
          item.disabled = card.dataset.variantAvailable !== 'true';
          item.removeAttribute('aria-busy');
          delete item.dataset.gnPending;
          item.textContent = card.dataset.variantAvailable === 'true' ? label : 'Esaurito';
        });
      }, 1800);
    }
  });
  root.addEventListener('click', (event) => {
    const tracked = event.target.closest('[data-gn-track]');
    if (!tracked || !root.contains(tracked)) return;
    const card = tracked.closest('[data-gn-card]'); window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'gn_product_grid', action: tracked.dataset.gnTrack, section: root.dataset.gnHeading, product_id: card?.dataset.productId || null, variant_id: card?.dataset.variantId || null });
  });
}

class GnCatalogProductList extends HTMLElement {
  connectedCallback() { init(this); }
}

if (!customElements.get('gn-catalog-product-list')) customElements.define('gn-catalog-product-list', GnCatalogProductList);

const scan = () => document.querySelectorAll('[data-gn-product-list]').forEach(init);
scan();
document.addEventListener('shopify:section:load', scan);
document.addEventListener('shopify:section:unload', scan);
